import Callout from '@/components/Callout.tsx';
import Form from '@/components/Form.tsx';
import { sanitizeHtml } from '@/utils/utils.ts';

import type { Label, StaticContent } from '@/types/types.ts';

interface PolicyHeroProps {
    contentData: StaticContent
    categories: Label[],
}

/**
 * Hero for the Policy Listing page
 * Displays data from the Policy Library page in WordPress
 */

export default function PolicyHero({contentData, categories}: PolicyHeroProps) {

    return (
	<div className="policy-library-listing-hero-grid">
                <div className="policy-library-listing-left">
                    <div className="policy-library-listing-intro">
                        <h1>{contentData?.title ? contentData.title : 'Policy Library'}</h1>
                        {contentData?.intro && <div dangerouslySetInnerHTML={sanitizeHtml(contentData.intro)}/>}
                    </div>
                    <hr className="policy-library-listing-form-divider"/>
                    <Form categories={categories} />
                </div>
                {contentData?.callout && ( <Callout contentData={contentData }/>
                    )}
            </div>
    )
}